import { createContext } from 'react'

export interface DonsModalContextValue {
  isOpen: boolean
  open: () => void
  close: () => void
}

export const DonsModalContext = createContext<DonsModalContextValue | null>(null)
